var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#1B49EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13420_16014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0591 18.0884C23.8913 18.0884 23.7304 18.1551 23.6117 18.2737C23.493 18.3924 23.4263 18.5534 23.4263 18.7212V20.8822C23.4263 21.3916 23.224 21.8801 22.8638 22.2403C22.5036 22.6005 22.0151 22.8028 21.5057 22.8028H10.4948C9.98543 22.8028 9.49693 22.6005 9.13675 22.2403C8.77657 21.8801 8.57422 21.3916 8.57422 20.8822V18.7212C8.57422 18.5534 8.50755 18.3924 8.38887 18.2737C8.2702 18.1551 8.10924 18.0884 7.94141 18.0884C7.77357 18.0884 7.61262 18.1551 7.49394 18.2737C7.37526 18.3924 7.30859 18.5534 7.30859 18.7212V20.8822C7.30943 21.727 7.64539 22.537 8.24274 23.1343C8.84009 23.7317 9.65003 24.0676 10.4948 24.0685H21.5057C22.3505 24.0676 23.1605 23.7317 23.7578 23.1343C24.3552 22.537 24.6911 21.727 24.692 20.8822V18.7212C24.692 18.5534 24.6253 18.3924 24.5066 18.2737C24.3879 18.1551 24.227 18.0884 24.0591 18.0884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5535 19.9361C15.6123 19.9954 15.6823 20.0425 15.7594 20.0746C15.8365 20.1067 15.9192 20.1233 16.0028 20.1233C16.0863 20.1233 16.169 20.1067 16.2461 20.0746C16.3232 20.0425 16.3932 19.9954 16.4521 19.9361L20.0528 16.3354C20.1532 16.2145 20.2051 16.0605 20.1983 15.9035C20.1915 15.7465 20.1265 15.5976 20.0159 15.4859C19.9054 15.3741 19.7572 15.3075 19.6002 15.299C19.4433 15.2906 19.2888 15.3408 19.1668 15.44L16.6356 17.9712V8.56445C16.6356 8.39662 16.5689 8.23566 16.4502 8.11699C16.3315 7.99831 16.1706 7.93164 16.0028 7.93164C15.8349 7.93164 15.674 7.99831 15.5553 8.11699C15.4366 8.23566 15.3699 8.39662 15.3699 8.56445V17.9617L12.8387 15.4305C12.72 15.3117 12.5589 15.245 12.391 15.245C12.2231 15.245 12.062 15.3117 11.9433 15.4305C11.8245 15.5492 11.7578 15.7103 11.7578 15.8782C11.7578 16.0461 11.8245 16.2072 11.9433 16.3259L15.5535 19.9361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13420_16014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDownloadBlue);
export default __webpack_public_path__ + "static/media/c_download_blue.eaee432dc1ef82aa112b513624df2f1e.svg";
export { ForwardRef as ReactComponent };